import React from 'react';
import { object, number, bool, func } from 'prop-types';
import { connect } from 'react-redux';
import { I18nProvider, I18n } from '@fiverr-private/fiverr_context';

import { Button } from '@fiverr-private/fit';
import PackageContent from '../../shared/PackageContent';
import FormGigItem from '../../shared/FormGigItem';
import { getPackageById } from '../../../reducers/packages';
import { MP_CLICKED_COMPARE_PACKAGES } from '../../../utils/mixPanelEvents';
import { shouldShowSelectPackage } from '../../../utils/shouldShowSelectPackage';
import { isVoiceOver } from '../../../utils/packagesUtils';

import './style.scss';

class Content extends React.Component {

    constructor() {
        super();

        this.onCompareClick = this.onCompareClick.bind(this);
    }

    onCompareClick(e) {
        e.preventDefault();

        const { biEvents } = this.context;
        const { onComparePackagesClick } = this.props;

        // todo refactor to redux action so that a callback function won't be passed
        onComparePackagesClick();
        biEvents.sendMixPanelEvent({ eventName: MP_CLICKED_COMPARE_PACKAGES });
    }

    render() {
        const {
            extraFast,
            id,
            currentPrice,
            inProgress,
            showCompareAnchor
        } = this.props;

        const { general, currencyConverter } = this.context;
        const showSelectPackage = shouldShowSelectPackage(general);
        const formattedPrice = currencyConverter.convert(currentPrice);

        const btnColor = general.isPro ? Button.COLORS.BLACK : Button.COLORS.GREEN;

        // todo: remove when VO package has a title
        const title = isVoiceOver(general) ? 'gig_page_perseus.packages.order_details' : '';

        return (
            <div className="content">
                {
                    extraFast &&
                    <FormGigItem packageId={id} id={extraFast.id} quantity={extraFast.currentValue}/>
                }
                <I18nProvider>
                    {({ i18n }) => (<PackageContent id={id} title={title ? i18n.t(title) : ''}/>)}
                </I18nProvider>
                <footer>
                    {showSelectPackage &&
                        <Button type="submit"
                            className="btn-continue"
                            disabled={inProgress}
                            color={btnColor}>
                            <I18n k={'gig_page_perseus.packages.continue'}/>
                            <span> ({formattedPrice})</span>
                        </Button>
                    }
                    {showCompareAnchor &&
                    <button className="btn-compare-packages" onClick={this.onCompareClick}>
                        <I18n k={'gig_page_perseus.packages_tabs.compare_packages'}/>
                    </button>
                    }
                </footer>
            </div>
        );
    }
}

Content.propTypes = {
    extraFast: object,
    id: number,
    currentPrice: number,
    inProgress: bool,
    onComparePackagesClick: func,
    showCompareAnchor: bool
};

Content.contextTypes = {
    biEvents: object,
    general: object,
    currencyConverter: object
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        ...packageData,
        onComparePackagesClick: ownProps.onComparePackagesClick
    };
};

Content.defaultProps = {
    onComparePackagesClick: () => true,
    showCompareAnchor: true
};

const ContentConnect = connect(mapStateToProps)(Content);

const TabContent = ({ id, onComparePackagesClick, showCompareAnchor }) => (
    <ContentConnect id={id}
        onComparePackagesClick={onComparePackagesClick}
        showCompareAnchor={showCompareAnchor}/>
);

export { Content };
export default TabContent;
